module.exports = __webpack_public_path__ + "img/delphoi.0862d0a6.png";